// mui
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    maxheight: "200px",
    margin: "10px auto",
    width: "290px",
    backgroundColor: "red",
    position: "relative",
    top: "0px",
    fontFamily: '"Poppins", sans-serif',

    "&:hover": {
      top: "-2.5px",
      backgroundColor: "",
      boxShadow: "0px 4px 8px rgba(38, 38, 38, 0.2)",
    },
  },

  second: {
    justifyItems: "center",
  },
}));

export default useStyles;
